import { ca } from '@cian/analytics';
import { TRegularInfrastructureItem } from '../../../types/map';
import { getBlockTypeByInfrastructureType } from './getBlockTypeByInfrastructureType';
import { toAnalyticsObjectType } from './toAnalyticsObjectType';

export function trackFullscreenShow(
  isFullscreen: boolean,
  infrastructureItems: TRegularInfrastructureItem[],
  infrastructureType?: string,
) {
  const objectType = toAnalyticsObjectType(infrastructureType);
  const blockType = getBlockTypeByInfrastructureType(infrastructureType, infrastructureItems);

  ca('eventSite', {
    action: 'fullscreen',
    category: 'Infrastructure',
    label: isFullscreen ? 'click_sopr' : 'close_sopr',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
